import axios from "../config"

class OrderService{
    axios;
    constructor(){
        this.axios = axios;
    }
    getOrderById(orderId) {
      let url = `/order/${orderId}`
      return axios.get(url).then(request => request.data);
    }
    addOrder(order) {
        let url = `/order`;
        return this.axios.post(url, order).then(request => request.data);
      }
      updateOrder(order) {
        let url = `/order/${order.orderId}`;
        return this.axios.put(url, order).then(request => request.data);
      }
    getOrderList(fromDate,toDate,osId,fBId,status,riderId,allCheckBox,balance) {
      let url = `/order/orderlist`
      return axios.get(url,{
          params:{
              fromDate,toDate,osId,fBId,status,riderId,allCheckBox,balance
          }
      }).then(request => request.data);
    }
    deleteOrder(item) {
      let url = `order/${item.orderId}`;
      return this.axios.delete(url).then(request => request.data);
    } 
    orderDone(item) {
      let url = `order/${item.orderId}/done`;
      return this.axios.put(url).then(request => request.data);
    } 
    orderCancel(item,remark) {
      let url = `order/${item.orderId}/cancel`;
      return axios.get(url,{
        params:{
            remark
        }
    }).then(request => request.data);
    } 
    getOrderDetailList(page) {
        let url = `/order/itemlist`
        return axios.get(url,{
            params:{
                page
            }
        }).then(request => request.data);
      }
      getItemToAssignlList(cityId,townshipId,status,riderId,osId,page,fbId,tbId,isTrue) {
        let url = `/order/item/toassignlist`
        return axios.get(url,{
            params:{
              cityId,townshipId,status,riderId,osId,page,fbId,tbId,isTrue
            }
        }).then(request => request.data);
      }
      getItemToAssignlListSearch(searchText,page) {
        let url = `/order/item/toassignlist/search`
        return axios.get(url,{
            params:{
              searchText,page
            }
        }).then(request => request.data);
      }
      getTrackingList(fromDate,toDate,status,osId,page,riderId,tsId,inputDate,fBId,tBId,collectorOrDeliverer,hidezero,
        dateUser,cityId) {
        let url = `/order/trackinglist`
        return axios.get(url,{
            params:{
              fromDate,toDate,status,osId,
                page,riderId,tsId,inputDate,fBId,tBId,collectorOrDeliverer,hidezero,dateUser,cityId
            }
        }).then(request => request.data);
      }
      getHistoryList(fromDate,toDate,status,osId,page,riderId,tsId,inputDate,fBId,tBId,collectorOrDeliverer,hidezero,dateUser) {
        let url = `/order/historylist`
        return axios.get(url,{
            params:{
              fromDate,toDate,status,osId,
                page,riderId,tsId,inputDate,fBId,tBId,collectorOrDeliverer,hidezero,dateUser
            }
        }).then(request => request.data);
      }
      getTrackingListSearch(searchText,page) {
        let url = `/order/trackinglist/search`
        return axios.get(url,{
            params:{
                searchText,
                page
            }
        }).then(request => request.data);
      }
      getOverdueList(status,page,fBId,tBId,cityId,tsId,osId,riderId,tsList) {
        let url = `/order/overduelist`
        return axios.get(url,{
            params:{
              status,page,fBId,tBId,cityId,tsId,osId,riderId,tsList
            }
        }).then(request => request.data);
      }
      getRiderList(riderId,fbId,activeOrinactive) {
        let url = `/order/riderlist`
        return axios.get(url,{
            params:{
                riderId,fbId,activeOrinactive
            }
        }).then(request => request.data);
      }
      getOSList(fromDate,toDate,typeDate,osId,hideZero,osDebit) {
        let url = `/order/oslist`
        return axios.get(url,{
            params:{
                fromDate,toDate,typeDate,osId,hideZero,osDebit
            }
        }).then(request => request.data);
      }
      getItemDetailRiderList(fromDate,toDate,riderId,status,typeDate,fBId,tBId) {
        let url = `/order/item/riderlist`
        return axios.get(url,{
            params:{
              fromDate,toDate,riderId,status,typeDate,fBId,tBId
            }
        }).then(request => request.data);
      }
      getItemDetailRiderListFinished(fromDate,toDate,riderId,pageId,fBId,tBId) {
        let url = `/order/item/riderlist/finished`
        return axios.get(url,{
            params:{
              fromDate,toDate,riderId,pageId,fBId,tBId
            }
        }).then(request => request.data);
      }
      getItemDetailOSList(fromDate,toDate,osId,status,typeDate,fBId,tBId) {
        let url = `/order/item/oslist`
        return axios.get(url,{
            params:{
              fromDate,toDate, osId,status,typeDate,fBId,tBId
            }
        }).then(request => request.data);
      }
      getItemDetailOSListFinished(fromDate,toDate,osId,pageId,fBId,tBId) {
        let url = `/order/item/oslist/finished`
        return axios.get(url,{
            params:{
              fromDate,toDate,osId,pageId,fBId,tBId
            }
        }).then(request => request.data);
      }
      getItemSearchById(itemId) {
        let url = `/order/item/search`
        return axios.get(url,{
            params:{
              itemId
            }
        }).then(request => request.data);
      }
      getDailyCheckList(fromDate,toDate,riderId,osId,action,fBId,zeroIndex,status) {
        let url = `/order/dailychecklist/`
        return axios.get(url,{
            params:{
                fromDate,toDate,riderId,osId,action,fBId,zeroIndex,status
            }
        }).then(request => request.data);
      }
      getDailyCheckListSearch(searchText) {
        let url = `/order/dailychecklist/search`
        return axios.get(url,{
            params:{
                searchText
            }
        }).then(request => request.data);
      }
      getCheckDetailRiderList(invoiceOsId,receivedDate,riderId,status) {
        let url = `/order/checkdetail/riderlist`
        return axios.get(url,{
            params:{
              invoiceOsId,receivedDate,riderId,status
            }
        }).then(request => request.data);
      }
      getCheckDetailOSList(invoiceOsId) {
        let url = `/order/checkdetail/oslist`
        return axios.get(url,{
            params:{
              invoiceOsId
            }
        }).then(request => request.data);
      }
      saveOrderPhoto(formData,orderId){
        let url = `order/${orderId}/photo`;
        return axios.post(url, formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(request => request.data);
    }
    getOrderPhoto(orderId) {
      let url = `/order/${orderId}/photo`
      return axios.get(url).then(request => request.data);
    }
    getDailyOutIn(fromDate,toDate,fbId,tbId) {
      let url = `/order/outin`
      return axios.get(url,{
          params:{
              fromDate,toDate,fbId,tbId
          }
      }).then(request => request.data);
    }
    getOutInDetail(outInId,status) {
      let url = `/order/outin/detail`
      return axios.get(url,{
          params:{
            outInId,status
          }
      }).then(request => request.data);
    }
    updateOutInbyItemId(dto) {
      let url = `/item/outin`
      return axios.put(url,dto).then(request => request.data);
    }
    getOutInTextSearch(search) {
      let url = `/order/outin/search`
      return axios.get(url,{
          params:{
            search
          }
      }).then(request => request.data);
    }
    updateReDate(invoiceOsId,data) {
      let url = `/order/update/remitdate/${invoiceOsId}`
      return axios.put(url,data).then(request => request.data);
    } 
    updateReDate(invoiceOsId,data) {
      let url = `/order/update/remitdate/${invoiceOsId}`
      return axios.put(url,data).then(request => request.data);
    } 
    updateOrderInvoiceOsCopy(invoiceOsId){
      let url = `order/invoiceos/${invoiceOsId}`;
      return axios.get(url).then(request => request.data);
  }
  getRiderListSearch(search,tranList) {
    let url = `/order/riderlist/search/${search}`
    return axios.put(url,tranList).then(request => request.data);
  }
  // getOrderListSearch(search,orderList) {
  //   let url = `/order/assignlist/search/${search}`
  //   return axios.put(url,orderList).then(request => request.data);
  // }
  orderFinish(order) {
    let url = `/order/${order.orderId}/finish`
    return axios.put(url).then(request => request.data);
  }
  orderDoneDone(order,status) {
    let url = `/order/${order.orderId}/donedone/${status}`
    return axios.get(url).then(request => request.data);
  }
  updateOrderRemark(orderId,order) {
    let url = `/order/${orderId}/remark`
    return axios.put(url,order).then(request => request.data);
  }
  getOrderListSearch(searchText) {
    let url = `/order/orderlist/search`
    return axios.get(url,{
        params:{
            searchText
        }
    }).then(request => request.data);
  }
  getOrderListAdvance(fromDate,toDate,osId,fBId,riderId,checkZero) {
    let url = `/order/orderlist/advance`
    return axios.get(url,{
        params:{
          fromDate,toDate,osId,fBId,riderId,checkZero
        }
    }).then(request => request.data);
  }
  updateOrderAdvance(orderId,item) {
    let url = `order/${orderId}/advance`;
    return this.axios.put(url,item).then(request => request.data);
  } 
  saveOrderItemCount(orderId,itemcount) {
    let url = `/order/${orderId}/itemCount/${itemcount}`
    return axios.get(url).then(request => request.data);
  }
  updatePickupByRiderId(riderId,empty,dto) {
    let url = `order/pickup/${riderId}/${empty}`;
    return this.axios.put(url,dto).then(request => request.data);
  } 
    getOrderedCount() {
    let url = `/order/noticount`
    return axios.get(url).then(request => request.data);
  }
}

const service = new OrderService();
export default service;